import React, { useState } from "react";

import { fakeCallBack, getAgencia, getEmpregado } from "../componentes/api/DataApi";
import "../css/fake.css";

export default function FakePage() {
    const [proposta, setProposta] = useState({
        id_pre_venda: 0,
        cpf: "",
        nome: "",
        celular: "",
        agencia: "",
        nome_agencia: "",
        formaVenda: "AGE",
        cpf_vendedor: "",
        matricula_vendedor: "",
        nome_vendedor: "",
        agencia1: "",
        conta1: "",
        digito1: "",
        agencia2: "",
        conta2: "",
        digito2: "",
        dataNascimento: "",
        cidade: "SAO PAULO",
        mei: "N",
        pf: {
            sexo: "F"
        },
        agencia3: "",
        conta3: "",
        digito3: "",
        uf: "SP"
    });

    const consultaAgencia = (agencia, retorno) => {
        getAgencia(agencia, (response) => {
            if (response && response.codigo === 0 && response.habilitada === 1) {
                retorno(response.nomeAgencia);
            }
            else {
                retorno(null);
            }
        });
    }

    const consultaVendedor = (cpf, agencia, retorno) => {
        getEmpregado(cpf, (response) => {
            if (response && response.codigo === 0 && response.codigoUnidade === parseInt(agencia, 10)) {
                retorno(response);
            }
            else {
                retorno(null);
            }
        });
    }

    const onSaiAgencia = () => {
        setProposta((atual) => ({ ...atual, nome_agencia: "" }));

        if (proposta.agencia.trim() !== "") {
            consultaAgencia(proposta.agencia, (nome) => {
                setProposta((atual) => ({ ...atual, nome_agencia: nome || "" }));
            });
        }
    }

    const onSaiVendedor = () => {
        setProposta((atual) => ({ ...atual, matricula_vendedor: "", nome_vendedor: "" }));

        if (proposta.cpf_vendedor.trim() !== "" && proposta.agencia.trim() !== "") {
            consultaVendedor(proposta.cpf_vendedor, proposta.agencia, (empregado) => {
                setProposta((atual) => ({
                    ...atual,
                    matricula_vendedor: empregado ? empregado.matricula : "",
                    nome_vendedor: empregado ? empregado.nome : ""
                }));
            });
        }
    }

    const enviaCallBack = (dados) => {
        fakeCallBack(dados, (response) => {
            if (response.codigo === 0) {
                localStorage.setItem("IdPreVenda", dados.id_pre_venda);

                alert("Cadastro efetuado com sucesso!");
                //navigate("/venda");
            }
            else
            {
                alert("Ocorreu um erro: " + response.mensagem);
            }
        })
    }

    const callback = () => {
        const cca = proposta.formaVenda === "CCA";

        if (proposta.agencia.trim() === "" || (!cca && proposta.cpf_vendedor.trim() === "")) {
            alert(cca ? "Agência deve ser informada" : "Agência e CPF do vendedor devem ser informados");

            return;
        }

        consultaAgencia(proposta.agencia, (nomeAgencia) => {
            if (nomeAgencia === null) {
                alert("Agência inválida");

                return;
            }

            if (cca) {
                const dados = { ...proposta, nome_agencia: nomeAgencia, cpf_vendedor: "", matricula_vendedor: "", nome_vendedor: "" };

                setProposta(dados);
                enviaCallBack(dados);

                return;
            }

            consultaVendedor(proposta.cpf_vendedor, proposta.agencia, (empregado) => {
                if (empregado === null) {
                    alert("Vendedor não encontrado ou não pertence à agência " + proposta.agencia);

                    return;
                }

                const dados = {
                    ...proposta,
                    nome_agencia: nomeAgencia,
                    cpf_vendedor: empregado.cpf,
                    matricula_vendedor: empregado.matricula,
                    nome_vendedor: empregado.nome
                };

                setProposta(dados);
                enviaCallBack(dados);
            });
        });
    }

    return (
        <div className="fake-page bg-padrao">
            <div className="fake-page__container">
                <div className="fake-page__header">
                    <h1 className="colorTextoPadrao">Pré-venda de teste</h1>
                    <p>Preencha os dados abaixo para simular um callback de criação de proposta.</p>
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Dados Pré-venda - Cliente</h2>
                    <div className="fake-page__grid">
                        <div className="fake-page__field">
                            <label htmlFor="tbxIdPreVenda">Id Pré-Venda</label>
                            <input type="text" id="tbxIdPreVenda" name="id_pre_venda" maxLength={9} value={proposta.id_pre_venda} onChange={(e) => setProposta({ ...proposta, id_pre_venda: e.target.value })} />
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="tbxCPF">CPF</label>
                            <input type="text" id="tbxCPF" name="cpf" value={proposta.cpf} onChange={(e) => setProposta({ ...proposta, cpf: e.target.value })} />
                        </div>

                        <div className="fake-page__field fake-page__field--full">
                            <label htmlFor="tbxNome">Nome</label>
                            <input type="text" id="tbxNome" name="nome" value={proposta.nome} onChange={(e) => setProposta({ ...proposta, nome: e.target.value })} />
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="tbxCelular">Celular</label>
                            <input type="text" id="tbxCelular" name="celular" value={proposta.celular} onChange={(e) => setProposta({ ...proposta, celular: e.target.value })} />
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="ddlSexo">Sexo</label>
                            <select id="ddlSexo" name="ddlSexo" value={proposta.pf.sexo} onChange={(e) => setProposta({ ...proposta, pf: { sexo: e.target.value } })}>
                                <option value="F">Feminino</option>
                                <option value="M">Masculino</option>
                            </select>
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="ddlUf">UF</label>
                            <select id="ddlUf" name="ddlUf" value={proposta.uf} onChange={(e) => setProposta({ ...proposta, uf: e.target.value })}>
                                <option value="SP">SP</option>
                                <option value="PB">PB</option>
                                <option value="RJ">RJ</option>
                                <option value="MG">MG</option>
                                <option value="AP">AP</option>
                            </select>
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="ddlMei">MEI</label>
                            <select id="ddlMei" name="ddlMei" value={proposta.mei} onChange={(e) => setProposta({ ...proposta, mei: e.target.value })}>
                                <option value="N">NÃO</option>
                                <option value="S">SIM</option>
                            </select>
                        </div>

                        <div className="fake-page__field fake-page__field--full">
                            <label htmlFor="tbxCidade">Cidade</label>
                            <input type="text" id="tbxCidade" name="cidade" value={proposta.cidade} onChange={(e) => setProposta({ ...proposta, cidade: e.target.value })} />
                        </div>

                        <div className="fake-page__field fake-page__field--full">
                            <label htmlFor="tbxDataNascimento">Data Nascimento</label>
                            <input type="text" id="tbxDataNascimento" name="dataNascimento" placeholder="AAAAMMDD" value={proposta.dataNascimento} onChange={(e) => setProposta({ ...proposta, dataNascimento: e.target.value })} />
                        </div>
                    </div>
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Dados Vendedor</h2>
                    <div className="fake-page__grid">
                        <div className="fake-page__field">
                            <label htmlFor="ddlFormaVenda">Forma de Venda</label>
                            <select id="ddlFormaVenda" name="formaVenda" value={proposta.formaVenda} onChange={(e) => setProposta({ ...proposta, formaVenda: e.target.value, cpf_vendedor: "", matricula_vendedor: "", nome_vendedor: "" })}>
                                <option value="CCA">CCA</option>
                                <option value="AGE">AGE</option>
                            </select>
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxAgencia">Agência</label>
                            <input type="text" id="tbxAgencia" name="agencia" value={proposta.agencia} onChange={(e) => setProposta({ ...proposta, agencia: e.target.value, nome_agencia: "", matricula_vendedor: "", nome_vendedor: "" })} onBlur={onSaiAgencia} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxNomeAgencia">Nome da Agência</label>
                            <input type="text" id="tbxNomeAgencia" name="nome_agencia" value={proposta.nome_agencia} readOnly={true} />
                        </div>
                        {proposta.formaVenda !== "CCA" && <>
                        <div className="fake-page__field">
                            <label htmlFor="tbxCpfVendedor">CPF Vendedor</label>
                            <input type="text" id="tbxCpfVendedor" name="cpf_vendedor" value={proposta.cpf_vendedor} onChange={(e) => setProposta({ ...proposta, cpf_vendedor: e.target.value, matricula_vendedor: "", nome_vendedor: "" })} onBlur={onSaiVendedor} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxMatriculaVendedor">Matrícula</label>
                            <input type="text" id="tbxMatriculaVendedor" name="matricula_vendedor" value={proposta.matricula_vendedor} readOnly={true} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxNomeVendedor">Vendedor</label>
                            <input type="text" id="tbxNomeVendedor" name="nome_vendedor" value={proposta.nome_vendedor} readOnly={true} />
                        </div>
                        </>}
                    </div>
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Contas</h2>

                    <div className="fake-page__account-grid">
                        <div className="fake-page__field">
                            <label htmlFor="tbxAgencia1">Agência 1</label>
                            <input type="text" id="tbxAgencia1" name="agencia1" value={proposta.agencia1} onChange={(e) => setProposta({ ...proposta, agencia1: e.target.value })} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxConta1">Conta 1</label>
                            <input type="text" id="tbxConta1" name="conta1" value={proposta.conta1} onChange={(e) => setProposta({ ...proposta, conta1: e.target.value })} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxDigito1">DV 1</label>
                            <input type="text" id="tbxDigito1" name="digito1" value={proposta.digito1} onChange={(e) => setProposta({ ...proposta, digito1: e.target.value })} />
                        </div>
                    </div>

                    <div className="fake-page__account-grid">
                        <div className="fake-page__field">
                            <label htmlFor="tbxAgencia2">Agência 2</label>
                            <input type="text" id="tbxAgencia2" name="agencia2" value={proposta.agencia2} onChange={(e) => setProposta({ ...proposta, agencia2: e.target.value })} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxConta2">Conta 2</label>
                            <input type="text" id="tbxConta2" name="conta2" value={proposta.conta2} onChange={(e) => setProposta({ ...proposta, conta2: e.target.value })} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxDigito2">DV 2</label>
                            <input type="text" id="tbxDigito2" name="digito2" value={proposta.digito2} onChange={(e) => setProposta({ ...proposta, digito2: e.target.value })} />
                        </div>
                    </div>

                    <div className="fake-page__account-grid">
                        <div className="fake-page__field">
                            <label htmlFor="tbxAgencia3">Agência 3</label>
                            <input type="text" id="tbxAgencia3" name="agencia3" value={proposta.agencia3} onChange={(e) => setProposta({ ...proposta, agencia3: e.target.value })} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxConta3">Conta 3</label>
                            <input type="text" id="tbxConta3" name="conta3" value={proposta.conta3} onChange={(e) => setProposta({ ...proposta, conta3: e.target.value })} />
                        </div>
                        <div className="fake-page__field">
                            <label htmlFor="tbxDigito3">DV 3</label>
                            <input type="text" id="tbxDigito3" name="digito3" value={proposta.digito3} onChange={(e) => setProposta({ ...proposta, digito3: e.target.value })} />
                        </div>
                    </div>
                </div>

                <div className="fake-page__actions">
                    <button type="button" className="botaoPadrao" onClick={callback}>Enviar</button>
                </div>
            </div>
        </div>
    )
}
